<template>
  <div class="nav-root">
    <!-- Overlay con blur (liquid glass) -->
    <div v-if="menuOpen" class="overlay" @click="toggleMenu"></div>

    <!-- Sidebar -->
    <aside class="sidebar" :class="{ open: menuOpen }" @click.stop>
      <!-- Header -->
      <div class="sb-header">
        <div class="brand">
          <img v-if="logoSrc" :src="logoSrc" alt="Logo" class="brand-logo" />
          <span class="brand-title">{{ brandTitle }}</span>
        </div>
        <button class="sb-close" @click="toggleMenu" aria-label="Cerrar menú">&times;</button>
      </div>

      <!-- Perfil mini-card -->
      <div class="profile-card">
        <div class="avatar">{{ initials }}</div>

        <div class="profile-info">
          <div class="profile-name">{{ displayName }}</div>

          <router-link
            :to="`/dashboard/user/edit/${user?.token}`"
            class="profile-edit"
            @click="closeMenu"
            title="Editar perfil"
          >
            <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
              <path
                fill="currentColor"
                d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25Zm2.92 2.33h-.83v-.83l8.9-8.9.83.83-8.9 8.9ZM20.71 7.04a1 1 0 0 0 0-1.41L18.37 3.29a1 1 0 0 0-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83Z"
              />
            </svg>
            Editar perfil
          </router-link>
        </div>
      </div>

      <!-- Links -->
      <ul class="sb-links">
        <li>
          <router-link to="/lista-usuarios" class="sb-link" @click="closeMenu">
            <span class="ico">
              <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
                <path
                  fill="currentColor"
                  d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3Zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3Zm0 2c-2.33 0-7 1.17-7 3.5V19h10v-2.5C11 14.17 6.33 13 4 13Zm12 0c-.29 0-.62.02-.97.05C17.65 13.84 19 14.82 19 16.5V19h4v-2.5C23 14.17 18.33 13 16 13Z"
                />
              </svg>
            </span>
            Gestión de invitados
          </router-link>
        </li>

        <li v-if="$canView('superadministrador')">
          <router-link to="/eventos" class="sb-link" @click="closeMenu">
            <span class="ico">
              <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
                <path
                  fill="currentColor"
                  d="M7 11h2v2H7v-2Zm4 0h2v2h-2v-2Zm4 0h2v2h-2v-2ZM7 15h2v2H7v-2Zm4 0h2v2h-2v-2Zm4 0h2v2h-2v-2ZM7 3h2v2H7V3Zm8 0h2v2h-2V3ZM5 5h14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7c0-1.1.9-2 2-2Zm0 4v10h14V9H5Z"
                />
              </svg>
            </span>
            Gestión de eventos
          </router-link>
        </li>

        <li v-if="$canView('superadministrador', 'administradorevento')">
          <router-link to="/buscador" class="sb-link" @click="closeMenu">
            <span class="ico">
              <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
                <path
                  fill="currentColor"
                  d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0 0 16 9.5 6.5 6.5 0 1 0 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79L20 20.5 21.5 19 15.5 14Zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14Z"
                />
              </svg>
            </span>
            Buscador
          </router-link>
        </li>

        <li v-if="$canView('superadministrador')">
          <router-link to="/recintos" class="sb-link" @click="closeMenu">
            <span class="ico">
              <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
                <path
                  fill="currentColor"
                  d="M12 2a7 7 0 0 0-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 0 0-7-7Zm0 9.5A2.5 2.5 0 1 1 12 6a2.5 2.5 0 0 1 0 5.5Z"
                />
              </svg>
            </span>
            Recintos
          </router-link>
        </li>

        <li v-if="$canView('superadministrador')">
          <router-link to="/planos" class="sb-link" @click="closeMenu">
            <span class="ico">
              <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
                <path
                  fill="currentColor"
                  d="M3 3h8v8H3V3Zm10 0h8v5h-8V3ZM3 13h8v8H3v-8Zm10 5h8v3h-8v-3Zm0-9h8v8h-8V9Z"
                />
              </svg>
            </span>
            Asignaciones reservas
          </router-link>
        </li>
        <li v-if="$canView('superadministrador')">
          <router-link to="/administracion-usuarios" class="sb-link" @click="closeMenu">
            <span class="ico">
              <!-- icono tipo users/gear -->
              <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
                <path fill="currentColor"
                  d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3ZM8 11c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3Zm0 2c-2.33 0-7 1.17-7 3.5V19h10v-2.5C11 14.17 6.33 13 4 13Zm12 0c-.72 0-1.54.09-2.39.29.23.34.39.75.39 1.21V19h6v-2.5c0-2.33-4.67-3.5-7-3.5ZM14.6 13.6l.9 1.56 1.78-.54.54 1.78 1.56-.9 1.22 1.22.9-1.56 1.78.54.54-1.78 1.56-.9-.54-1.78 1.78-.54-.9-1.56 1.22-1.22-1.56-.9.54-1.78-1.78-.54-.9-1.56-1.22 1.22-1.56-.9-.54 1.78-1.78.54.9 1.56-1.22 1.22Z"
                />
              </svg>
            </span>
            Administración de usuarios
          </router-link>
        </li>
        <li v-if="$canView('superadministrador')">
          <router-link to="/auditoria-usuarios" class="sb-link" @click="closeMenu">
            <span class="ico">
              <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
                <path fill="currentColor" d="M4 3h16a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Zm0 4v12h16V7H4Zm2 3h3v6H6v-6Zm5-2h3v8h-3V8Zm5 4h2v4h-2v-4Z" />
              </svg>
            </span>
            Auditoría de usuarios
          </router-link>
        </li>
        <li v-if="$canView('superadministrador')">
          <router-link to="/panel-mantenimiento" class="sb-link" @click="closeMenu">
            <span class="ico">
              <svg viewBox="0 0 24 24" width="18" height="18"><path fill="currentColor" d="M10 6h10v2H10V6ZM4 6h4v2H4V6Zm6 10h10v2H10v-2ZM4 16h4v2H4v-2Zm10-5h6v2h-6v-2ZM4 11h8v2H4v-2Z"/></svg>
            </span>
            Panel de control
          </router-link>
        </li>
      </ul>

      <!-- Logout abajo -->
      <div class="sb-footer">
        <button class="logout" @click="logoutAndClose">
          <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
            <path
              fill="currentColor"
              d="M13 3h-2v10h2V3Zm-1 18A8 8 0 0 1 4 13a7.96 7.96 0 0 1 3-6.22l1.22 1.6A6 6 0 1 0 18 13a5.98 5.98 0 0 0-2.22-4.62l1.22-1.6A8 8 0 0 1 12 21Z"
            />
          </svg>
          Cerrar sesión
        </button>
      </div>
    </aside>

    <!-- Topbar -->
    <nav class="topbar">
      <div class="topbar-inner">
        <button class="hamburger" @click="toggleMenu" aria-label="Abrir menú">
          &#9776;
        </button>
      </div>
    </nav>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import logoUrl from "@/assets/logo.png"; // cámbialo si tu logo vive en otro lugar

export default {
  name: "AppShellNav",
  data() {
    return { menuOpen: false };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    displayName() {
      return this.user?.username || "Usuario";
    },
    initials() {
      const name = (this.user?.username || "").trim();
      if (!name) return "US";
      const parts = name.split(/\s+/);
      return (parts.length >= 2 ? parts[0][0] + parts[1][0] : name.slice(0, 2)).toUpperCase();
    },
    brandTitle() {
      return this.$store.state.securityMode ? 'Sponsors (Security)' : 'Sponsors';
    },
    logoSrc() {
      return logoUrl;
    },
  },
  methods: {
    ...mapActions(["logout"]),
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
      document.documentElement.classList.toggle("no-scroll", this.menuOpen);
    },
    closeMenu() {
      if (!this.menuOpen) return;
      this.menuOpen = false;
      document.documentElement.classList.remove("no-scroll");
    },
    logoutAndClose() {
      this.logout();
      this.closeMenu();
      // si quieres redirigir como en refactor, descomenta:
      // this.$router.push('/login')
    },
  },
  beforeUnmount() {
    document.documentElement.classList.remove("no-scroll");
  },
};
</script>

<style lang="sass" scoped>
/* =========================================================
   NAVBAR (Refactor look) – Tema A friendly (tokens globales)
   ========================================================= */

:global(.no-scroll)
  overflow: hidden

.nav-root
  /* Tokens (toman tus vars globales del tema A) */
  --primary: var(--color-primary, #2563EB)
  --neutral: var(--color-neutral, #111827)

  --topbar-bg: var(--neutral)
  --topbar-text: #fff

  --sb-text: #fff
  --sb-link: rgba(255,255,255,.92)
  --glass-stroke: rgba(255,255,255,.18)
  --glass-shadow: 0 14px 40px rgba(0,0,0,.28)

  --overlay-bg: rgba(10, 15, 25, .35)
  --overlay-blur: 18px
  --overlay-saturate: 160%
  --overlay-brightness: 90%

/* Overlay con blur */
.overlay
  position: fixed
  inset: 0
  z-index: 40
  backdrop-filter: blur(var(--overlay-blur)) saturate(var(--overlay-saturate)) brightness(var(--overlay-brightness))
  -webkit-backdrop-filter: blur(var(--overlay-blur)) saturate(var(--overlay-saturate)) brightness(var(--overlay-brightness))
  background: radial-gradient(60% 60% at 10% 10%, rgba(255,255,255,.10) 0%, transparent 60%), var(--overlay-bg)

/* Sidebar glass (oscuro) */
.sidebar
  position: fixed
  top: 0
  left: 0
  height: 100%
  width: 272px
  max-width: 80vw
  transform: translateX(-100%)
  transition: transform .35s cubic-bezier(.22,.61,.36,1)
  z-index: 50
  display: flex
  flex-direction: column
  color: var(--sb-text)

  background: linear-gradient(to bottom right, rgba(17,24,39,.86), rgba(17,24,39,.66))
  border-right: 1px solid var(--glass-stroke)
  box-shadow: var(--glass-shadow)
  backdrop-filter: blur(22px) saturate(140%)
  -webkit-backdrop-filter: blur(22px) saturate(140%)

  &.open
    transform: translateX(0)

.sb-header
  display: flex
  align-items: center
  justify-content: space-between
  padding: .75rem 1rem
  border-bottom: 1px solid var(--glass-stroke)

.brand
  display: flex
  align-items: center
  gap: .55rem

.brand-logo
  width: 28px
  height: 28px
  object-fit: contain

.brand-title
  font-weight: 800
  font-size: 1rem
  color: var(--topbar-text)

.sb-close
  color: var(--sb-text)
  font-size: 1.6rem
  line-height: 1
  background: transparent
  border: 0
  cursor: pointer
  padding: .25rem
  border-radius: 10px
  &:hover
    background: rgba(255,255,255,.08)

/* Perfil */
.profile-card
  display: grid
  grid-template-columns: 48px 1fr
  gap: .75rem
  padding: 1rem
  border-bottom: 1px solid var(--glass-stroke)

.avatar
  width: 48px
  height: 48px
  border-radius: 9999px
  display: grid
  place-items: center
  font-weight: 900
  letter-spacing: .5px
  background: var(--primary)
  color: #fff
  box-shadow: inset 0 0 0 2px rgba(255,255,255,.14)

.profile-info
  display: flex
  flex-direction: column
  gap: .25rem

.profile-name
  font-weight: 800
  line-height: 1.1
  padding: 0 .5rem
  color: var(--sb-text)

.profile-edit
  display: inline-flex
  align-items: center
  gap: .4rem
  padding: .25rem .5rem
  border-radius: 10px
  font-size: .85rem
  color: var(--sb-link)
  text-decoration: none
  transition: background .15s ease, color .15s ease
  &:hover
    background: rgba(255,255,255,.08)
    color: #fff

/* Links */
.sb-links
  list-style: none
  margin: 0
  padding: .55rem
  display: flex
  flex-direction: column
  gap: .25rem
  overflow-y: auto

.sb-link
  display: flex
  align-items: center
  gap: .6rem
  padding: .62rem .75rem
  border-radius: 12px
  text-decoration: none
  color: var(--sb-text)
  transition: background .15s ease
  &:hover
    background: rgba(255,255,255,.08)
  &.router-link-active
    background: rgba(255,255,255,.12)

.ico
  display: grid
  place-items: center
  width: 22px
  opacity: .95

/* Footer */
.sb-footer
  margin-top: auto
  padding: .75rem
  border-top: 1px solid var(--glass-stroke)

.logout
  width: 100%
  display: inline-flex
  align-items: center
  justify-content: center
  gap: .5rem
  padding: .65rem .75rem
  background: rgba(255,255,255,.06)
  border-radius: 12px
  border: 1px solid rgba(255,255,255,.16)
  color: var(--sb-text)
  cursor: pointer
  transition: background .15s ease, border-color .15s ease
  &:hover
    background: rgba(255,255,255,.10)
    border-color: rgba(255,255,255,.24)

/* Topbar */
.topbar
  position: fixed
  top: 0
  left: 0
  right: 0
  height: 56px
  background: var(--topbar-bg)
  color: var(--topbar-text)
  z-index: 30
  border-bottom: 1px solid rgba(255,255,255,.10)

.topbar-inner
  height: 100%
  display: flex
  align-items: center
  padding: 0 .75rem

.hamburger
  padding: .42rem .56rem
  font-size: 1.2rem
  line-height: 1
  border-radius: 10px
  color: var(--topbar-text)
  background: rgba(255,255,255,.06)
  border: 1px solid rgba(255,255,255,.18)
  cursor: pointer
  transition: background .15s ease, border-color .15s ease
  &:hover
    background: rgba(255,255,255,.10)
    border-color: rgba(255,255,255,.26)
</style>
